import React, { Component } from "react";
import { Link } from "react-router-dom";
import Helping from "../../helpers/Helping";
import Service from "../../helpers/service";
import Notification from "../layout/Notification";
import route from '../../config/routes';
import { addCurrentRoute } from '../../actions/profile_action';
import { connect } from 'react-redux';
import { MESSAGE } from '../../config/index';
import {
    API_URL,
    META_MASK,
    MATIC_META_MASK,
    TEZOS_META_MASK,
    STORE_WEBSITE
} from '../../config/urls';
import LoadingButton from "../fields/LoadingButton";
import { trackPromise } from "react-promise-tracker";

const { NOT_FOUND } = MESSAGE;
class Detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
            auction: {},
            pageTitle: 'Action Detail',
            routeName: '/auction',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsEnable: false,
            totalAmount: 0,
            completeAuction: {
                isLoading: false
            }
        };
    }

    componentDidMount() {
        var self = this;
        if (this.props.match.params.id) {

            self.setState({
                url: API_URL.ADMIN_TRADING_API + route.GET_AUCTION
            }, function () {
                self.getById();
                this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
            });
        }
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    getById() {
        let self = this;

        trackPromise(Service.postCall(this.state.url, {
            action: 'detail',
            auction_id: this.props.match.params.id,
        })
            .then((response) => {
                var auction = response.data.payload;

                self.setState({
                    auction: auction,
                    isLoading: false,
                });
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return self.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        isLoading: false,
                    });
                }
                return this.setState({
                    isLoading: false,
                    ...Helping.setNetworkRequestError(error, 'fetching auction'),
                });
            })
        )
    }

    getMetaMaskLink = (copy) => {
        if (copy.which_bc === "MATIC")
            return MATIC_META_MASK.LINK + copy.id;

        else if (copy.which_bc === "ETH")
            return META_MASK.LINK + copy.id;

        else if (copy.which_bc === "TEZOS")
            return TEZOS_META_MASK.LINK + copy.id;
    }

    roundValue(amount) {
        return Math.round(amount * 10) / 10;
    }

    completeAuction = () => {
        let self = this;
        let { completeAuction } = self.state;
        completeAuction.isLoading = true;

        this.setState({
            completeAuction: completeAuction
        })

        Service.postCall(this.state.url, {
            action: 'complete',
            auctionId: this.props.match.params.id,
        }, Helping.getConfig())
            .then((response) => {
                completeAuction.isLoading = false;
                self.setState({
                    completeAuction: completeAuction,
                    error_message: response.data.message,
                    error_type: 'success'
                });

                self.getById();
            })
            .catch((error) => {
                completeAuction.isLoading = false;

                if (error.response) {
                    self.setState({
                        completeAuction: completeAuction,
                        error_message: error.response.data.message,
                        error_type: 'success'
                    });
                }
            })
    }

    render() {
        let { auction, completeAuction } = this.state
        let { item_detail, bidding } = auction

        return (
            <div class="content user-view">
                {auction.status && (
                    <>
                        <div class="top-header">
                            <div class="header-title">
                                <h2 class="title">{auction.owner.username}</h2>
                                <span class="title-caption">Owner</span>
                            </div>
                            <div class="header-btn">
                                <button class="custom-btn dark-btn icon-btn sm-btn" onClick={() => this.props.history.goBack()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                        <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                            <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                                <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                            </g>
                                        </g>
                                    </svg>
                                    <span class="txt-btn">Back</span>
                                </button>

                                {!auction.is_completed && (
                                    completeAuction.isLoading ?
                                        <LoadingButton class_name={"sm-btn"} />
                                        :
                                        <button class="custom-btn gradiant-btn sm-btn" onClick={this.completeAuction}>{completeAuction.isLoading ? "Loading..." : "Complete Auction"}</button>
                                )}
                            </div>
                        </div>

                        {this.state.error_message && (
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        )}

                        <div class="main-content  view-page-content">
                            <div class="view-tabs multiple-tabs">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#auctionDetail" role="tab">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                <path id="Path_380" data-name="Path 380" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,2a8,8,0,1,1-8,8A8,8,0,0,1,12,4Zm0,11a1,1,0,1,1-1,1A1,1,0,0,1,12,15Zm1-7v5a1,1,0,0,1-2,0V8a1,1,0,0,1,2,0Z" transform="translate(-2 -2)" />
                                            </svg>

                                            <span class="tab-text">Details</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#auctionProductInfo" role="tab">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                <path id="Star" d="M12.136,2.531a1.71,1.71,0,0,0-1.489,1.122L8.523,8.207l-4.847.726A1.664,1.664,0,0,0,2.757,11.9l3.485,3.53-.823,4.984c-.27,1.625,1.039,2.618,2.439,1.848.536-.295,3.258-1.816,4.277-2.376l4.309,2.376c1.4.77,2.683-.223,2.408-1.848l-.824-4.984,3.486-3.53A1.664,1.664,0,0,0,20.6,8.933l-4.848-.726L13.625,3.653A1.708,1.708,0,0,0,12.136,2.531Zm0,2.738,2.059,4.39a.981.981,0,0,0,.76.561l4.658.693-3.39,3.4a1.109,1.109,0,0,0-.285.957l.792,4.785-4.118-2.277a.988.988,0,0,0-.951,0c-.517.284-3.01,1.668-4.118,2.277l.792-4.785a1.126,1.126,0,0,0-.285-.957l-3.39-3.4,4.658-.66a1.017,1.017,0,0,0,.76-.594Z" transform="translate(-2.136 -2.531)" />
                                            </svg>
                                            <span class="tab-text">Product Info</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#auctionBidDetail" role="tab">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                <path id="bidDetail" d="M5.6,2A3.816,3.816,0,0,0,2,6V18a3.816,3.816,0,0,0,3.6,4H16.4A3.816,3.816,0,0,0,20,18V6a3.816,3.816,0,0,0-3.6-4Zm0,2H16.4a1.907,1.907,0,0,1,1.8,2V18a1.907,1.907,0,0,1-1.8,2H5.6a1.907,1.907,0,0,1-1.8-2V6A1.907,1.907,0,0,1,5.6,4Zm9.9,2a.954.954,0,0,1,.9,1,.954.954,0,0,1-.9,1h-9a.954.954,0,0,1-.9-1,.954.954,0,0,1,.9-1Zm0,5a1.006,1.006,0,0,1,0,2h-9a1.006,1.006,0,0,1,0-2Zm0,5a1.006,1.006,0,0,1,0,2h-9a1.006,1.006,0,0,1,0-2Z" transform="translate(-2 -2)" />
                                            </svg>
                                            <span class="tab-text">Bid Detail</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="tab-content">
                                <div class="tab-pane active" id="auctionDetail" role="tabpanel">
                                    <div class="row">
                                        <div class="col-sm-6 col-md-6 col-lg-4">
                                            <ul class="list-view">
                                                <li>
                                                    <label for="">ID</label>
                                                    <span>{auction.id}</span>
                                                </li>
                                                <li>
                                                    <label for="">Owner</label>
                                                    <span>{auction.owner.username}</span>
                                                </li>
                                                <li>
                                                    <label for="">Status</label>
                                                    <span>{Helping.getTitleCase(auction.status)}</span>
                                                </li>
                                                <li>
                                                    <label for="">Completed</label>
                                                    <span>{Helping.getTitleCase(auction.is_completed ? "True" : "False")}</span>
                                                </li>
                                                <li>
                                                    <label for="">Extended</label>
                                                    <span>{Helping.getTitleCase(auction.is_extended ? "True" : "False")}</span>
                                                </li>
                                                <li>
                                                    <label for="">BuyNow</label>
                                                    <span>{Helping.getTitleCase(auction.is_completed_buynow ? "True" : "False")}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-5">
                                            <ul class="list-view">
                                                <li>
                                                    <label for="">Start Amountt</label>
                                                    <span>${parseFloat(auction.start_amount).toFixed(2)}</span>
                                                </li>
                                                <li>
                                                    <label for="">Reserved Amount</label>
                                                    <span>${parseFloat(auction.reserved_amount).toFixed(2)}</span>
                                                </li>
                                                <li>
                                                    <label for="">Buy Now Amount</label>
                                                    <span>${parseFloat(auction.buy_now_amount).toFixed(2)}</span>
                                                </li>
                                                <li>
                                                    <label for="">Created at</label>
                                                    <span>{Helping.convertTimeToHumanReadableFormat(auction.created_at)}</span>
                                                </li>
                                                <li>
                                                    <label for="">Expire at</label>
                                                    <span>{Helping.convertTimeToHumanReadableFormat(auction.expire_at)}</span>
                                                </li>
                                                <li>
                                                    <label for="">Public Key</label>
                                                    <span>{auction.owner.pub_key}</span>
                                                </li>
                                            </ul>
                                        </div>

                                        {auction.reason && (
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <ul class="list-view">
                                                    <li>
                                                        <label for="">Reason</label>
                                                        <span>{auction.reason}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {item_detail && (
                                    <div class="tab-pane" id="auctionProductInfo" role="tabpanel">
                                        <div class="listing-tbl table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">ID</th>
                                                        <th scope="col">Product Name</th>
                                                        <th class="text-center" scope="col">Image</th>
                                                        <th scope="col">Code</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">IP</th>
                                                        <th scope="col">Brand</th>
                                                        <th scope="col">Blockchain</th>
                                                        <th scope="col">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td scope="row">{item_detail.id}</td>
                                                        <td class=" ">{item_detail.item.name}</td>
                                                        <td>
                                                            <div class="newsCoverImg">
                                                                <img src={item_detail.item.thumbnail_url} alt="" class="img-fluid" />
                                                            </div>
                                                        </td>
                                                        <td>{item_detail.code}</td>
                                                        <td>${Helping.parseAmount(item_detail.amount)}</td>
                                                        <td><div class=" ">{item_detail.item.ip.name}</div></td>
                                                        <td>{item_detail.item.brand.name}</td>
                                                        <td>{item_detail.which_bc}</td>
                                                        <td>
                                                            <div class="action-links">
                                                                <a class="icon location" title='Blockchain Info' target="_blank"
                                                                    href={this.getMetaMaskLink(item_detail)}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                                                                </a>
                                                                <a href={STORE_WEBSITE + 'item/' + item_detail.code} class="icon view" title="View Item Detail">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="13.5" viewBox="0 0 17.5 13.5">
                                                                        <g id="Show" transform="translate(0.75 0.75)">
                                                                            <path id="Stroke_1" data-name="Stroke 1" d="M5.469,2.6A2.669,2.669,0,0,1,2.734,5.2,2.668,2.668,0,0,1,0,2.6,2.668,2.668,0,0,1,2.734,0,2.669,2.669,0,0,1,5.469,2.6Z" transform="translate(5.266 3.402)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                            <path id="Stroke_3" data-name="Stroke 3" d="M8,12c3.293,0,6.306-2.25,8-6-1.7-3.75-4.708-6-8-6H8C4.708,0,1.7,2.25,0,6c1.7,3.75,4.708,6,8,6Z" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                        </g>
                                                                    </svg>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}

                                {bidding && (
                                    <div class="tab-pane" id="auctionBidDetail" role="tabpanel">
                                        <div class="listing-tbl table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Username</th>
                                                        <th scope="col">Public Key</th>
                                                        <th scope="col">Bid Amount</th>
                                                        <th scope="col">Bid Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bidding.map((bid, i) => (
                                                        <tr key={i}>
                                                            <td class=" ">{bid.user.username}</td>
                                                            <td class=" ">{bid.user.pub_key}</td>
                                                            <td>${Helping.parseAmount(bid.bid_amount)}</td>
                                                            <td>{Helping.convertTimeToHumanReadableFormat(bid.created_at)}</td>
                                                        </tr>
                                                    )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
                {(!auction.status && !this.state.isLoading) && (
                    <div className="table-responsive">
                        <Notification type="danger"
                            message={Helping.getMessageString(NOT_FOUND, "Auction")}
                            callback={this.removeNetworkError} />
                    </div>
                )
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile
})

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);